// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Vyk2","col":"CardReaderDesc_col__1dq_w","label":"CardReaderDesc_label__67X4y"};